<script>
	import VentasVendedor from "./components/stats/VentasVendedor.svelte";
	import VentasDia from "./components/stats/VentasDia.svelte";
	import AcumuladoProducto from "./components/stats/AcumuladoProducto.svelte";
	import AcumuladoSucursal from "./components/stats/AcumuladoSucursal.svelte";
    import { push } from "svelte-spa-router";
    import Helper from './components/Helper.svelte';
    import Navbar from "./components/Navbar.svelte";
    import Titlesection from "./components/Titlesection.svelte";
    import { login, miPermiso, urlapi,superadmin, sucursalStore, sucursal } from "./stores/store";
    import AnimationContainer from './components/AnimationContainer.svelte';
    import Input from './componentes/Forms/Input.svelte';
    import {breakpoint, platform} from './components/MediaQuery.svelte'
    import { moneda, object2array, postData } from "./scripts";
    import moment from "moment";

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.stats.access!==true ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    let helper=false;
    let cargando=false;
    //$superadmin=false;
    let acumulado_sucursal=[];
    let acumulado_producto=[];
    let ventas_dia=[];
    let ventas_usuario=[];
    let sucursal_search=($superadmin===true)?'ALL':$sucursal;

    let AcumuladoSucursalView='ALL';
    let AcumuladoProductoView='ALL';
    let VentasDiaView='ALL';
    let VentasVendedorView='ALL';

    let desde=moment().startOf('week').add(1, "days").format('YYYY-MM-DD');
    let hasta=moment().endOf('week').add(1, "days").format('YYYY-MM-DD');

    async function loadData()
    {
        let datos={ 
          'cmd': "stats_graficas",
          'desde':desde,
          'hasta':hasta,
          'sucursal':sucursal_search,
        }

        cargando=true;
        const res = await postData($urlapi, [datos])
        .then(data => {
            acumulado_sucursal=object2array(data[0].acumulado_sucursal);
            acumulado_producto=object2array(data[0].acumulado_producto);
            ventas_dia=object2array(data[0].ventas_dia);
            ventas_usuario=object2array(data[0].ventas_usuario);    
            cargando=false;
        });          
    }
    loadData();

    function eventSearch(event)
    {
        if(desde=='0000-00-00' || desde=='') desde=hasta;
        if(hasta=='0000-00-00' || hasta=='') hasta=desde;
        loadData()
    }    
    let sucursal_combo=[{'ALL':'Todas'}];
    if(Object.getOwnPropertyNames($sucursalStore).length>0) {
            for (const property in $sucursalStore ) {
                sucursal_combo=[...sucursal_combo,{[property]:$sucursalStore[property]}]
            }
    }

    function setView(state)
    {
        AcumuladoSucursalView=state;
        AcumuladoProductoView=state;
        VentasDiaView=state;
        VentasVendedorView=state;
    }

</script>

{#if viewPage===true}

<Navbar/>
<AnimationContainer>

    <Titlesection>
        <span slot="title"><i class="bi bi-bar-chart-line me-1" />Estadísticas</span>
        <span slot="toolbar">
            <span on:mouseenter={()=>helper='Ver solo Gráficas en todas las estadísticas'} on:mouseleave={()=>helper=false}>
                <button class='btn btn-warning text-white' on:click={()=>setView('CHART')}><i class="bi bi-bar-chart-line-fill"></i></button>
            </span>

            <span on:mouseenter={()=>helper='Ver solo Tablas en todas las estadísticas'} on:mouseleave={()=>helper=false}>
                <button class='btn btn-warning text-white' on:click={()=>setView('TABLE')} ><i class="bi bi-table"></i></button>
            </span>            

            <span on:mouseenter={()=>helper='Ver Gráficas y Tablas en todas las estadísticas'} on:mouseleave={()=>helper=false}>
                <button class='btn btn-warning text-white text-nowrap' on:click={()=>setView('ALL')}><i class="bi bi-bar-chart-line-fill me-1"></i><i class="bi bi-table"></i></button>
            </span>
        </span>
    </Titlesection>

    <div class="container mt-4">
        <div class="row">
            <div class="d-flex justify-content-between flex-column flex-md-row">
                <div class='mb-3'>
                    <Input label='Fecha' bind:value={desde} bind:value2={hasta} tipo='range' on:change={eventSearch} />
                </div>
                {#if $superadmin===true}
                    <div class='mb-3'>
                        <Input label='Sucursal' bind:value={sucursal_search} tipo='select' on:change={eventSearch} datos={sucursal_combo} />
                    </div>
                {/if}
            </div>
        </div>
    </div>


    <div class="container mt-4">
        <div class="row">
            <div class="col-12 col-lg-6 p-3" class:border-end={$breakpoint=='lg' || $breakpoint=='xl'  || $breakpoint=='xxl'} class:border-bottom={$breakpoint=='lg' || $breakpoint=='xl'  || $breakpoint=='xxl'}>
                <AcumuladoSucursal data={acumulado_sucursal} view={AcumuladoSucursalView}/>
            </div>
            <div class="col-12 col-lg-6 p-3" class:border-bottom={$breakpoint=='lg' || $breakpoint=='xl'  || $breakpoint=='xxl'}>
                <AcumuladoProducto data={acumulado_producto} view={AcumuladoProductoView}/>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-lg-6 p-3" class:border-end={$breakpoint=='lg' || $breakpoint=='xl'  || $breakpoint=='xxl'}>
                <VentasDia data={ventas_dia} view={VentasDiaView}/>
            </div>
            <div class="col-12 col-lg-6 p-3">
                <VentasVendedor data={ventas_usuario} view={VentasVendedorView}/>
            </div>
        </div>        
    </div>
    <br/><br/>

    <Helper bind:text={helper}></Helper>
</AnimationContainer>
{/if}